"use client";
import {
  Card,
  Group,
  Stack,
  Text,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { LimitType } from "./types";

interface McLaBreakdownProps {
  subjectNameLower: string;
  mcValue: number;
  laValue: number;
  limitType: LimitType;
}

export default function McLaBreakdown({
  mcValue,
  subjectNameLower,
  laValue,
  limitType,
}: McLaBreakdownProps) {
  const theme = useMantineTheme();
  const colorScheme = useComputedColorScheme("light");
  const units = limitType === "questions" ? "questions" : "minutes";

  return (
    <Card
      p="md"
      radius="md"
      withBorder
      style={{
        minWidth: "min(100%,300px)",
        background:
          colorScheme === "dark"
            ? theme.colors.dark[6]
            : "rgba(255,255,255,0.75)",
        alignItems: "center",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        justifyItems: "center",
        gap: theme.spacing.lg,
      }}
    >
      <Stack gap={0} style={{ minWidth: 0 }}>
        <Text size="xs" c="dimmed" fw={600} tt="uppercase" mb="xs">
          Multiple Choice
        </Text>
        <Group gap={6} align="baseline" wrap="nowrap">
          <Text
            fw={700}
            size="lg"
            style={{ lineHeight: 1 }}
            c={subjectNameLower}
          >
            {mcValue}
          </Text>
          <Text size="xs" c="dimmed">
            {units}
          </Text>
        </Group>
      </Stack>

      <Stack gap={0} style={{ minWidth: 0 }}>
        <Text size="xs" c="dimmed" fw={600} tt="uppercase" mb="xs">
          Long Answer
        </Text>
        <Group gap={6} align="baseline" wrap="nowrap">
          <Text
            fw={700}
            size="lg"
            style={{ lineHeight: 1 }}
            c={subjectNameLower}
          >
            {laValue}
          </Text>
          <Text size="xs" c="dimmed">
            {units}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
}
